export default function NumberField({ label, value, onChange, color, testid, disabled }) {
  return (
    <div>
      <label className="block text-[10px] font-mono-stat uppercase tracking-widest text-slate-400 mb-1">
        {label}
      </label>
      <input
        data-testid={testid}
        type="number"
        min="0"
        disabled={disabled}
        value={value ?? 0}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 bg-slate-900 border border-white/10 rounded-lg font-mono-stat font-bold text-center disabled:opacity-70"
        style={{ color }}
      />
    </div>
  );
}
